import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Stakeholders by Support Level',
      type: 'charts',
      alias: 'stakeholders-by-support-level',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Support Level',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Stakeholders',
                          color: '#4285F4',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Supportive',
                                  y: {
                                    '#': {
                                      '@': 'supportiveStakeholders',
                                    },
                                  },
                                  name: 'Supportive',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      changeChampion: 'Yes',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                  description:
                                    'Stakeholders whose Change Champion value is Yes.',
                                },
                              },
                              {
                                '{}': {
                                  x: 'Neutral / Potential',
                                  y: {
                                    '#': {
                                      '@': 'potentialSupportStakeholders',
                                    },
                                  },
                                  name: 'Neutral / Potential',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      changeChampion:
                                                        'Potential',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                  description:
                                    'Stakeholders whose Change Champion value is Potential.',
                                },
                              },
                              {
                                '{}': {
                                  x: 'Low Support',
                                  y: {
                                    '#': {
                                      '@': 'lowSupportStakeholders',
                                    },
                                  },
                                  name: 'Low Support',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      changeChampion: 'No',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                  description:
                                    'Stakeholders whose Change Champion value is No.',
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Support Level',
                  yLabel: 'Stakeholder Count',
                  description:
                    'Calculated from the existing Change Champion field.',
                },
              },
            ],
          },
          type: 'bar',
          config: {
            '{}': {
              yAxis: {
                '{}': {
                  min: 0,
                  tickInterval: 1,
                  allowDecimals: false,
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    lowSupportStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!change_champion',
          },
          'No',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    supportiveStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!change_champion',
          },
          'Yes',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    potentialSupportStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!change_champion',
          },
          'Potential',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
  },
}
